export const languageName: any = {
  en: 'English',
  zh: '繁體中文',
  vn: 'Tiếng Việt',
  id: 'Indonesia'
}

export const validLanguages: any = [`en`, `zh`, `vn`, `id`]